// EDITIONS FABS-CI — Constantes entreprise (Sprint 0)
export const COMPANY = {
  nom: "EDITIONS FABS-CI",
  adresse:
    "Bingerville, Quartier N'Gotto, Immeuble Cité Angan A. fils et petits-fils, RDC, BP 693",
  telephones: ["+225 07 59 73 71 23", "+225 21 22 80 09 95"],
  email: "edition693fabs@gmail.com",
  dg: "ALI MAMIN",
  devise: "FCFA",
  tva: "Exonéré 0%",
  anneeScolaire: "2026-2027",
  slogan: "Les livres sont des fenêtres par lesquelles on regarde le monde",
  banques: [
    { nom: "CORIS BANK", compte: "C116 01011 007630824101 34" },
    { nom: "SGBCI", compte: "CI008 01123012343259990 95" },
  ],
};

export const ROLES = {
  super_admin: "Super Administrateur",
  directeur_general: "Directeur Général",
  comptable: "Comptable",
  directeur_commercial: "Directeur Commercial",
  gestionnaire_stock: "Gestionnaire de Stock",
  responsable_magasinier: "Responsable Magasinier",
  secretariat: "Secrétariat",
  service_logistique: "Service Logistique",
};

export const PALETTE = {
  navy: "#0A2540",
  orange: "#FF6200",
  red: "#C62828",
  green: "#2E7D32",
  greyLight: "#F5F5F5",
  white: "#FFFFFF",
};
